import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// material-ui
import { Card, Button, Switch, Grid, FormControlLabel, Checkbox, Dialog } from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { getTerms, updateTermIndex } from 'services/termServices';
import PreviewComponent from './_previewComponent';
import TableV2Component from 'components/TopCourtComponents/Table/Tablev2Component';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import { orderTypeOption } from 'constant/constant';
import { getCategories } from 'services/categoryServices';
import AddTerm from './addTerm';



export default function Terms({
    merchantId,
    placeId
}) {

    const [orderType, setOrderType] = useState([])
    const [categoryOptions, setCategoryOptions] = useState([])
    const [rows, setRows] = useState([])
    const [isAllCategory, setisAllCategory] = useState(false)
    const [categories, setCategories] = useState([])
    const [isSort, setIsSort] = useState(true)
    const [loading, setLoading] = useState(false)
    const [openDialog, setOpenDialog] = useState({
        open: false
    })

    const navigate = useNavigate()

    useEffect(() => {
        setOrderType([orderTypeOption[0].value])
    }, [])

    useEffect(() => {
        if (orderType && orderType.length > 0) {
            loadData()
            if (merchantId) {
                console.log('here merchantId', merchantId)
                getServiceCategory(orderType)
            }
        }
    }, [orderType, merchantId])

    useEffect(() => {
        if (orderType && orderType.length > 0) {
            loadData()
        }
        validateCategoryPick()
    }, [categories])

    const loadData = async () => {
        try {
            let { data, error } = await getTerms({ 
                orderTypes: orderType.toString(), 
                categories: categories.toString(), 
                merchantId: merchantId,
                placeId: placeId
            });
            if (error) throw error
            if (data) {
                setRows(data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getServiceCategory = async (e) => {
        try {
            let { data, error } = await getCategories({
                merchantId
            });
            if (error) throw error;
            if (data) {
                setCategoryOptions(
                    data.map((item) => ({
                        label: item.name,
                        value: item._id,
                    }))
                );
                validateCategoryPick()
            }
        } catch (error) {
            console.log(error);
        }
    };

    function validateCategoryPick() {
        if ((categories.length === categoryOptions.length)) {
            setisAllCategory(true)
        } else {
            setisAllCategory(false)
        }
    }

    const valueCustomatorSort = (row) => {
        return ({
            title: <div style={{ display: 'flex' }}>{isSort && <DragIndicatorIcon sx={{ color: 'gray' }} />}<span className='span-link' onClick={() => { navigate(`/term-and-condition/edit/${row._id}`) }}>{row.title}</span></div>,
            assigns: <TCLabel>{row.assignments.map((assignment, index) => (<span key={row}>{assignment}{index < row.assignments.length - 1 ? ', ' : ''}</span>))}</TCLabel>,
        })
    }

    const onChange = (e) => {
        return (e)
    }

    const setUpdateTermIndex = async (e) => {
        try {
            setRows(e)
            // map the data first
            let body = []
            for (let i = 0; i < e.length; i++) {
                body.push({
                    _id: e[i]._id,
                    index: i
                })
            }
            let { data, error } = await updateTermIndex({
                indexData: body
            })
            if (error) { throw error }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <Card style={{ marginBottom: 10, padding: 16, borderTopLeftRadius: 0, borderTopRightRadius: 0  }}>
                <Button sx={{ mb: 2 }} variant="contained" disableElevation onClick={() => {
                    // open popup
                    setOpenDialog({
                        open: true
                    })
                }}>Add Term</Button>
                <Grid item container xs={12} md={12}>
                    <Grid item xs={12} style={{ p: 1 }}>
                        <TCLabel style={{ fontSize: 13, color: "rgb(133, 133, 133)" }}>Order Type</TCLabel>
                    </Grid>
                    <Grid item container md={12} xs={12}>
                        {orderTypeOption.map(value => {
                            return (
                                <Grid item xs>
                                    <FormControlLabel control={<Checkbox id={`${value.value}-court-checkbox`}
                                        checked={orderType.indexOf(value.value) >= 0}
                                        onChange={() => {
                                            // onChange({allCourt: !form.allCourt})
                                            let types = orderType || []
                                            let currIndex = types.indexOf(value.value)
                                            if (currIndex >= 0) {
                                                if (orderType.length == 1) { return; }
                                                types.splice(currIndex, 1)
                                            } else {
                                                types.push(value.value)
                                            }
                                            if (!(orderType.indexOf('add_on') >= 0 ||
                                                orderType.indexOf('service') >= 0 ||
                                                orderType.indexOf('rent') >= 0 ||
                                                orderType.indexOf('buy') >= 0)) {
                                                setisAllCategory(false)
                                                setCategories([])
                                            }
                                            setOrderType([...types])
                                            // onChange({ isAllCourt: courtTypes.length == courtTypeOption.length, courtTypes: courtTypes })
                                        }} />} label={<TCLabel>{value.label}</TCLabel>} />
                                </Grid>
                            )
                        })
                        }
                    </Grid>
                </Grid>
                <Grid item container xs={12} md={12}>
                    <Grid xs={12}>
                        <TCLabel style={{ fontSize: 13, color: "rgb(133, 133, 133)" }}>Category</TCLabel>
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <FormControlLabel control={<Checkbox id="all-court-checkbox" checked={isAllCategory ? true : false} onChange={() => {
                            setisAllCategory(!isAllCategory)
                            if (isAllCategory) { setCategories([]) }
                            else {
                                let categories = categoryOptions.map(v => { return v.value })
                                console.log('categories', categories)
                                setCategories([...categories])
                            }
                        }} />}
                            disabled={
                                (orderType.indexOf('add_on') >= 0 ||
                                    orderType.indexOf('service') >= 0 ||
                                    orderType.indexOf('rent') >= 0 ||
                                    orderType.indexOf('buy') >= 0) ? false : true
                            }
                            label={<TCLabel>All Category</TCLabel>} />
                    </Grid>
                    <Grid item container md={12} xs={12}>
                        {categoryOptions.map(value => {
                            return (
                                <Grid item xs={6} sm={6} md={4} lg={2}>
                                    <FormControlLabel style={{
                                        whiteSpace: 'nowrap'
                                    }} control={<Checkbox className='checkboxCont' id={`${value.value}-court-checkbox`}
                                        disabled={
                                            (orderType.indexOf('add_on') >= 0 ||
                                                orderType.indexOf('service') >= 0 ||
                                                orderType.indexOf('rent') >= 0 ||
                                                orderType.indexOf('buy') >= 0) ? false : true
                                        }
                                        checked={categories.indexOf(value.value) >= 0}
                                        onChange={() => {
                                            onChange({ isAllCategory: false })
                                            let types = categories || []
                                            let currIndex = types.indexOf(value.value)
                                            if (currIndex >= 0) {
                                                types.splice(currIndex, 1)
                                            } else {
                                                types.push(value.value)
                                            }
                                            setCategories([...types])
                                        }} />} label={<TCLabel>{value.label}</TCLabel>} />
                                </Grid>
                            )
                        })
                        }
                    </Grid>
                </Grid>
            </Card>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                    <Card sx={{ mb: 3 }}>
                        <TableV2Component
                            columns={[
                                { label: "Title" },
                                { label: "Assign To" },
                            ]}
                            rows={rows}
                            valueCustomator={valueCustomatorSort}
                            onLoading={loading}
                            onDragEnd={(e) => {
                                setUpdateTermIndex(e)
                            }}
                        />
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                    <PreviewComponent data={rows} orderType={orderType.toString()} />
                </Grid>
            </Grid>
            <Dialog
                open={openDialog.open}
                onClose={() => setOpenDialog({
                    open: false
                })}
            >
                <AddTerm merchantId={merchantId} placeId={placeId}/>
            </Dialog>
        </>
    )
}